/**
 * @generated SignedSource<<614c33d990aeca6ef954736208b6f925>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type board_workManagementBoard_BoardContent_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"column_workManagementBoard_BoardColumn">;
  readonly " $fragmentType": "board_workManagementBoard_BoardContent_queryFragment";
};
export type board_workManagementBoard_BoardContent_queryFragment$key = {
  readonly " $data"?: board_workManagementBoard_BoardContent_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"board_workManagementBoard_BoardContent_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "board_workManagementBoard_BoardContent_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "column_workManagementBoard_BoardColumn"
    }
  ],
  "type": "Query"
};

(node as any).hash = "b8a8643969c0f675daf6dfd3b705a211";

export default node;
